const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Copy content into a canvas field', () => {
  describe('preview copying a simple string field', () => {
    const mock = loadRecordedMock('copy_field_canvas_string_preview.json');
    const n = 24;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?canvas&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a simple string field', () => {
    const mock = loadRecordedMock('copy_field_commit_canvas_string.json');
    const n = 24;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvas&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a simple string field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_canvas_string_repeat.json'
    );
    const n = 24;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvas&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying a rich text field', () => {
    const mock = loadRecordedMock('copy_field_canvas_rich_preview.json');
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?canvas&rich',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a rich text field', () => {
    const mock = loadRecordedMock('copy_field_commit_canvas_rich.json');
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvas&rich',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a rich text field', () => {
    const mock = loadRecordedMock('copy_field_commit_canvas_rich_repeat.json');
    const n = 24;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvas&rich&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying a rich text field using a template', () => {
    const mock = loadRecordedMock(
      'copy_field_canvas_rich_template_preview.json'
    );
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?canvas&rich&template',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a rich text field using a template', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_canvas_rich_template.json'
    );
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvas&rich&template',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a rich text field using a template', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_canvas_rich_template_repeat.json'
    );
    const n = 24;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvas&rich&template&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview converting rich text fields to canvas inside components inside existing canvas fields using a template', () => {
    const mock = loadRecordedMock(
      'copy_field_canvascomponentsrichtexttocanvas_preview.json'
    );

    it(`should return 1 entry to update`, (done) => {
      migratortronApi.post(
        'copy/field?canvascomponentsrichtexttocanvas',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(1);
          done();
        }
      );
    });
  });

  describe('convert rich text fields to canvas inside components inside existing canvas fields using a template', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_canvascomponentsrichtexttocanvas.json'
    );

    it(`should update the entry`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvascomponentsrichtexttocanvas',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(1);
          done();
        }
      );
    });
  });

  describe('repeat the same convert rich text fields to canvas inside components inside existing canvas fields using a template', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_canvascomponentsrichtexttocanvas_repeat.json'
    );

    it(`should return 1 entry with no entries to update`, (done) => {
      migratortronApi.post(
        'copy/field/commit?canvascomponentsrichtexttocanvas&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(1);
          expect(jpath('existing.*.totalCount', body)).to.equal(1);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
